'use client'

import { SectionHead, useReveal } from '@/components/page-kit'
import { MarginList, MarginRow } from './margin-list'
import { LMS_MODULES } from './data'

/* The six modules as catalogue entries hanging off the margin rule. The shared
   template renders them as six identical chips in a 3-column grid. */

export function LmsCurriculum() {
  const list = useReveal<HTMLDivElement>(0.1)

  return (
    <section className="pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead
          eyebrow="The curriculum"
          title="The LMS centralizes curriculum management, content distribution, assessments, and analytics within a secure digital ecosystem."
        />

        <div ref={list.ref} className="mt-10 sm:mt-12">
          <MarginList shown={list.shown}>
            {LMS_MODULES.map((m, i) => (
              <MarginRow
                key={m.name}
                index={i}
                shown={list.shown}
                className="py-4 sm:py-5"
              >
                <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6">
                  <h3 className="font-heading text-base font-normal leading-snug text-foreground sm:text-lg">
                    {m.name}
                  </h3>
                  <p className="text-[13px] leading-snug text-muted-foreground sm:shrink-0 sm:text-sm">
                    {m.description}
                  </p>
                </div>
              </MarginRow>
            ))}
          </MarginList>
        </div>
      </div>
    </section>
  )
}
